import { AuthService } from '../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Output } from '@angular/core';
import {
  ApplicationRouteURL,
  IKeyValueInterface
} from '../../shared/config';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { TwoFAService } from '../models/TwoFa.service';
import { TranslateService } from '../../shared/translate';

@Component({
  selector: 'Wego-Popup-two-fa-email-otp',
  template: require('../views/two-fa-email-otp.html'),
  providers: [TwoFAService]
})
export class TwoFAEmailOTPPopupComponent implements OnInit {
  apiErrorMsg: string;
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  bodyHTMLText: string;
  isLoading: boolean = false;
  googleSetupCode: any;
  totp: string="";

  constructor(
    public authService: AuthService,
    private router: Router,
    private TwoFAService: TwoFAService,
    private translate: TranslateService,
    private locationService: Location,
  ) { }

  ngOnInit() {
   // this.SendOTP();
  }

  public OnSubmit(forms: any) {
    this.TwoFAService.VerifyTwoFaEmailOtp(this.totp)
      .subscribe(
        res => {
          if (res.data) {
            let role = localStorage.getItem('current_role');

            if (role.toUpperCase() == 'WEGOADMIN') {
              this.router.navigate(['/wegoadmin']);
            } else if (role.toUpperCase() == 'ADMIN') {
              this.router.navigate(['/admin']);
            }
          }
          else {
            this.errorMessage = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public ResendOTP() {
    this.SendOTP();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public SendOTP() {
    this.TwoFAService.SendEmailOTP()
      .subscribe(
        res => {
          if (res.data) {
            this.googleSetupCode = res.data;
          }
          else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public NavigateTo() {
    this.router.navigate(['/privacystatement/popup']);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/twofa/components/two-fa-email-otp.ts